export const LanguagesInNewYork = [
  {
    heading: "Document",
    detail:
      "Are you thinking of traveling abroad? You might need documents for your migration. How about your piles and piles of business documents? Our document translation services can fulfill your requirements with certified translations.",
    link: "/document-translation-services",
    secondHeading: "Translation Services",
  },
  {
    heading: "Legal ",
    detail:
      "Tomedes is known for our legal translations because we combine expertise with the law and a native and multilingual approach to translation. Make sure your legal translation service in NYC can do the best for you.",
    link: "/legal-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Technical",
    detail:
      "For all technical business terminologies, Tomedes' expert translators in NYC can verify that your translations follow the current trends. That's by combining excellence in languages with technical expertise.",
    link: "/technical-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Marketing",
    detail:
      "For all your marketing and advertising copies, Tomedes' localization teams can broaden your horizons to grow in new markets. That's why in New York, translation can help overcome boundaries and set you up for growth.",
    link: "/marketing-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Interpreting",
    detail:
      "Interpreting services in New York City is necessary for a broad section of the populace. Choosing one of the best interpreting services is necessary for all types of interpretation--whether it be simultaneous, consecutive, or more.",
    link: "/interpretation-services",
    secondHeading: "Services",
  },
  {
    heading: "Website",
    detail:
      "Our localization experts know all about how to build and optimize a website for multilingual needs. Translation and localization are key aspects for international websites, so website translation services can help you translate in NYC for the whole world.",
    link: "/website-translation.php",
    secondHeading: "Translation Services",
  },
];

export const DemandsInNewYork = [
  {
    heading: "Chinese",
    detail:
      "Chinese is the second most spoken language in NYC spoken by 419,000 people. Chinese is also one of the primary languages for business. Tomedes' translation services in NYC can make sure your company is versed in traditional and simplified Chinese.",
    link: "/mandarin-chinese-translation",

    secondHeading: "Translation Services",
  },
  {
    heading: "Russian ",
    detail:
      "Russian is the fourth most spoken language in the greater NYC area. Our experienced translators in NYC can ensure that both business terminologies and the Russian language are accommodated.",
    link: "/russian-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "French",
    detail:
      "French Creole and French are both spoken by 160,000 and 81,000 people respectively. Native certified translators in NYC can handle both languages effectively. So why not go with Tomedes--who can ensure your translations live up to expectations.",
    link: "/french-translation.php",
    secondHeading: "Translation Services",
  },
  {
    heading: "Spanish",
    detail:
      "25% and 1.87 million people of New York City residents speak Spanish. That's just in NYC alone. Reaching these clients through NYC translation services could help boost your business. It's how Tomedes' Spanish translation services can up your conversion rates when it comes to Spanish-speaking clients.",
    link: "/spanish-translation.php",

    secondHeading: "Translation Services",
  },
  {
    heading: "Italian",
    detail:
      "If you're looking to translate Italian in New York, then you should know that 29% of the population and 294,271 people are Italian speakers. Italian is an important language for New York business, that's why Tomedes' global translation services in NYC can fulfill your linguistic needs.",
    link: "/italian-translation.php",
    secondHeading: "Translation Services",
  },
];
